import { render, staticRenderFns } from "./GoodsInventory.vue?vue&type=template&id=2aed3eea&scoped=true"
import script from "./GoodsInventory.vue?vue&type=script&lang=js"
export * from "./GoodsInventory.vue?vue&type=script&lang=js"
import style0 from "./GoodsInventory.vue?vue&type=style&index=0&id=2aed3eea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aed3eea",
  null
  
)

export default component.exports